// extracted by mini-css-extract-plugin
export default {"page":"style_page__mg7DL","form":"style_form__c1hky","title":"style_title__034Hm","label":"style_label__BLjm2","input":"style_input__z58A8","button":"style_button__JRncs"};